import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "OM_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#OM_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F50101"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "OM_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#OM_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#F50101", d: "M0 0h12v24H0z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.77 2.033c.01-.092-.107-.127-.153-.048-.363.617-1.273 2.084-2.77 4.002v-.919c-.143-.155-.599-.573-.599-.573V3.58l.824-.745L6.941 2l-1.193.834.902.745v.916c0 .44-.547.573-.547.573l-.1.809c-1.393-1.81-2.261-3.22-2.63-3.85-.047-.081-.166-.043-.152.05.111.737.443 2.373 1.36 4.119h-.246v.597h.266c.09.208.296.354.538.358.17.261.353.521.552.778-.458-.045-3.479-.302-3.479.797 0 .656.735 1.004 1.657 1.183l-2.207 1.995c-.065.059-.014.16.072.14.72-.179 2.606-.729 4.402-1.954h.055c.506 0 .857-.22 1.102-.516 1.826 1.49 3.893 2.179 4.79 2.426.093.025.143-.095.064-.15a27.172 27.172 0 01-4.051-3.49l.044-.052c.344-.405.643-.822.903-1.24a.596.596 0 00.244-.275h.265v-.597h-.018l.019-.038V7.49c0 .048.039.087.087.087h2.108a.087.087 0 00.087-.087V6.163a.087.087 0 00-.087-.087H9.64a.087.087 0 00-.056.02 12.358 12.358 0 001.187-4.063zm-8.718 4.13c0-.048.04-.087.087-.087h2.109c.048 0 .087.039.087.087v1.326a.087.087 0 01-.087.087H2.139a.087.087 0 01-.087-.087V6.163zm3.588.397a.487.487 0 01-.49.484.487.487 0 01-.488-.484c0-.267.219-.484.489-.484s.489.217.489.484zm2.608 0c0 .267.219.484.489.484s.489-.217.489-.484a.487.487 0 00-.49-.484c-.27 0-.488.217-.488.484z",
      fill: "#F7FCFF"
    }
  )))
), t = a;
export {
  t as default
};
